export default function getDay(date) {
  return (new Date(date)).getDate()
}